<template>
    <div
        id="feedback-page"
        :style="{
            background: `linear-gradient(0deg,${backgroundColorFirst},${backgroundColorSecond})`,
            color: 'white',
        }"
    >
        <div v-if="loading" class="loading-bar">
            <img src="./svg/asset/loading.gif" />
        </div>
        <div v-else class="feedback-page-container">
            <div class="stars">
                <div class="stars-container">
                    <div class="avatar" v-if="participants.length">
                        <a-avatar :username="agentName()" :src="getAgentImage()" class="avatar">
                            {{ agentName().substr(0, 1).toUpperCase() }}
                        </a-avatar>
                    </div>
                    <div class="content">
                        <div class="visitor-title" style="color: var(--form-color-text)" v-if="participants.length">
                            <span class="representative-name">{{ participants[0].name }}</span>
                            <span class="representative-desc">{{ $t("visitorLanguage.rateTheMeting") }}</span>
                        </div>
                        <a-rate v-model="starPoint" />
                    </div>
                </div>
            </div>
            <div class="company-feedback">
                <div class="title">{{ $t("visitorLanguage.confirmExperience") }}</div>
                <div
                    class="item"
                    v-for="(item, index) in companyFBIcon"
                    :key="index"
                    @click="(item) => startClickHandler(item)"
                >
                    {{ item.icon }}
                </div>
            </div>
            <div class="info">
                <div class="title" style="color: var(--form-color-text)">
                    {{ $t("visitorLanguage.suggestion") }}
                </div>
                <div class="text-area" style="color: var(--form-color-text)">
                    <textarea
                        style="font-size: 15px; min-width: 215px; margin-left: 15px"
                        v-model="description"
                        @change="(e) => textAreaChangeHandler(e)"
                        :placeholder="$t('message.writePlaceHolder')"
                    />
                </div>
                <div class="icon-wrapper">
                    <DynamicSvg :name="'TextArea'" :color="'var(--primary_)'" />
                </div>
            </div>
            <div class="button-wrapper">
                <div style="display: flex; justify-content: center; gap: 20%">
                    <button class="btn-send btn" style="width: 100px" @click="reconnect">
                        {{ $t("visitorLanguage.skip") }}
                    </button>
                    <button class="btn-send btn" @click="send" :style="{ opacity: buttonOpacity }">
                        {{ $t("visitorLanguage.send") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import Button from "../../common/Button.vue";
import DynamicSvg from "../../common/DynamicSvg.vue";
import { sendSocketMessage } from "../../utils/socketStream";
import { log2 } from "../../utils/log2";
import _ from "lodash";
import { sessionId } from "../../utils/session";
import version from "../../utils/version";

const log = log2("FeedBack");
export default {
    name: "FeedBack",
    components: { Button, DynamicSvg },
    props: {
        agent: {
            type: String,
        },
        participants: {
            type: Array,
        },
    },
    data() {
        return {
            starPoint: 0,
            companyFBIcon: [
                { icon: "😭", point: 1 },
                { icon: "😟", point: 2 },
                { icon: "🤨", point: 3 },
                { icon: "😁", point: 4 },
                { icon: "🤩", point: 5 },
            ],
            description: null,
            buttonOpacity: 0.5,
            loading: false,
        };
    },
    methods: {
        ...mapActions({
            resetConversation: "chat/resetConversation",
            toggleAfterActions: "app/toggleAfterActions",
            toggleRating: "app/toggleRating",
        }),
        ...mapMutations({
            changePageIndex: "app/CHANGE_PAGE",
        }),
        getRatedChatIds() {
            if (!localStorage.getItem("rated-chat-ids")) {
                localStorage.setItem("rated-chat-ids", JSON.stringify([]));
            }
            return JSON.parse(localStorage.getItem("rated-chat-ids"));
        },
        setRatedChatIds(ratedChats) {
            localStorage.setItem("rated-chat-ids", JSON.stringify(ratedChats));
        },
        send() {
            if (this.starPoint >= 1 || this.description) {
                log("send");
                let desc = this.description;

                sendSocketMessage("visitor rating", {
                    visitorId: this.visitorId,
                    conversationId: this.conversationId,
                    point: this.starPoint,
                    description: desc,
                    siteId: this.site._id,
                });

                const ratedChats = this.getRatedChatIds();
                ratedChats.push(this.conversationId);
                this.setRatedChatIds(ratedChats);
                this.changePageIndex(6);

                this.buttonOpacity = 1;
            }
        },
        startClickHandler(chosen) {},
        textAreaChangeHandler(e) {
            this.description = e.target.value;
            e.focus();
        },
        changePageIndexByStorage() {
            const ratedChats = this.getRatedChatIds();
            if (ratedChats.some((id) => id === this.conversationId)) {
                this.changePageIndex(6);
            }
        },
        agentName() {
            return this.participants.length ? this.participants[0].name : this.$t("message.representative");
        },
        getAgentImage() {
            if (this.chatAgents.length > 0) {
                if (this.chatAgents[0]._id === "chatbot") {
                    if (
                        this.settings.chatbotAvatar &&
                        this.settings.chatbotAvatar.path &&
                        this.settings.chatbotAvatar.id &&
                        this.settings.chatbotAvatar.ext
                    ) {
                        return `https://static.supsis.live/${this.settings.chatbotAvatar.path}${this.settings.chatbotAvatar.id}.${this.settings.chatbotAvatar.ext}`;
                    } else {
                        return null;
                    }
                } else {
                    if (this.chatAgents[0].gravatar) {
                        return this.chatAgents[0].gravatar;
                    } else {
                        return null;
                    }
                }
            }
            return null;
        },
        connect() {
            sendSocketMessage("visitor connect", {
                visitorId: this.visitorId,
                conversationId: this.conversationId,
                siteId: this.site._id,
                sessionId,
                version,
            });
        },
        reconnect() {
            this.loading = true;
            this.disconnect();
            setTimeout(() => {
                this.changePageIndex(1);
                this.toggleRating(false);
                this.toggleAfterActions(false);
                this.resetConversation();
                this.connect();
                this.loading = false;
            }, 1000);
        },

        disconnect() {
            sendSocketMessage("visitor disconnect", {
                visitorId: this.visitorId,
                conversationId: this.conversationId,
                siteId: this.site._id,
            });
        },
        updateButtonOpacity() {
            if (this.starPoint >= 1 || this.description) {
                this.buttonOpacity = 1;
            } else {
                this.buttonOpacity = 0.5;
            }
        },
    },
    computed: {
        ...mapState({
            chatAgents: (state) => state.chat.chatAgents,
            visitorId: (state) => state.chat.visitorId,
            conversationId: (state) => state.chat.lastConversationId,
            site: (state) => state.site.site,
            visitingPage: (state) => state.app.visitingPage,
            settings: (state) => state.setting.settings,
            backgroundColorFirst: (state) =>
                _.get(
                    state,
                    "setting.settings.chatCustomizationSettings.versionV2Theme.colors.backgroundColorFirst",
                    "#fff"
                ),
            backgroundColorSecond: (state) =>
                _.get(
                    state,
                    "setting.settings.chatCustomizationSettings.versionV2Theme.colors.backgroundColorSecond",
                    "#fff"
                ),
        }),
    },

    mounted() {
        window.addEventListener("reconnect-event", this.reconnect);
        window.addEventListener("storage", this.changePageIndexByStorage);
    },
    watch: {
        starPoint: "updateButtonOpacity",
        description: "updateButtonOpacity",
        visitingPage() {
            if (this.visitingPage === 1) {
                this.reconnect();
            }
        },
        reconnect() {
            this.changePageIndex(1);
            this.toggleRating(false);
            this.toggleAfterActions(false);
            this.resetConversation();
            this.connect();
        },
    },
    beforeDestroy() {
        window.removeEventListener("reconnect-event", this.reconnect);
        window.removeEventListener("storage", this.changePageIndexByStorage);
    },
};
</script>
<style lang="scss">
#feedback-page {
    .feedback-page-container {
        width: 100%;
        height: 100%;
        padding: 20px 15px;

        .stars {
            margin-bottom: 20px;

            .stars-container {
                display: flex;
                align-items: flex-start;

                .avatar {
                    width: 60px;
                    height: 60px;
                    border-radius: 100px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 18px;
                    font-weight: bold;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .content {
                    margin-left: 10px;

                    .visitor-title {
                        display: block;
                        font-size: 16px;
                        font-weight: 700;
                        line-height: 21px;
                        color: var(--primary_text);
                        margin-bottom: 10px;
                    }

                    .ant-rate {
                        font-size: 25px !important;
                    }
                }
            }
        }

        .company-feedback {
            display: none; // backend yapıldığında açılacak :)
            .title {
                font-size: 28px;
                font-weight: 700;
                line-height: 33px;
                color: #38386e;
            }

            .item {
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #e9ecf2;
                border-radius: 50%;

                &:not(:last-child) {
                    margin-right: 10px;
                }

                &.click {
                    background: var(--background-color-first);
                }
            }
        }

        .info {
            width: 100%;
            position: relative;

            .title {
                margin-bottom: 10px;
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
                color: var(--primary_text);
                display: flex !important;
                justify-content: center !important;
            }

            .text-area {
                display: flex;

                border: 1px solid #ebebeb;
                border-radius: 25px;
                height: 205px;
                overflow: hidden;
                padding: 10px;
                padding-left: 25px;

                textarea {
                    width: 100%;
                    height: 100%;
                    resize: none;
                    outline: none;
                    border: none;
                    color: var(--primary_text);
                    background-color: transparent;
                }
            }

            .icon-wrapper {
                position: absolute;
                top: 43px;
                left: 20px;
            }
        }

        .button-wrapper {
            position: initial;
            padding-top: 10px;
            bottom: 10px;
        }
    }

    .btn-send {
        width: 100% !important;
        background: var(--button-color);
        border: transparent;
        border-radius: 5px;
        color: var(--header-text-color);
    }
}
.loading-bar {
    margin: 0 auto;
    width: 150px !important;
    height: 150px !important;
    margin-top: 150px;
}
.representative-name {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
}
.representative-desc {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
}
</style>



// WEBPACK FOOTER //
// src/components/V2/FeedBack.vue